import { DynamicStandaloneButton, DynamicStandaloneButtonProps } from '@/components/Button';
import { componentTheme } from '@/styles/Row';
import { StandaloneComponent } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';

export type RowButtonProps = DynamicStandaloneButtonProps;

export const RowButtonComponent: StandaloneComponent<RowButtonProps> = (props) => {
  return (
    <DynamicStandaloneButton
      {...mergeProps(
        {
          options: {
            theme: componentTheme('button'),
          },
        },
        props
      )}
    />
  );
};
